import { Loader } from "./Loader";
import { Input } from "./Input";
import { List } from "./List";

export class InputCollection {

    public inputs: Input[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;
        let listReference = dataView.getInt32(offset, true);
        offset += 4;

        this.inputs = loader.getBlob<List>(listReference).getItems<Input>();
    }

    public getInput(semantic: string) : Input {
        let input = this.inputs.find(input => input.semantic == semantic)

        return input ? input : null;
    }
}
